import React, { useState, useEffect } from 'react';
import { Snackbar, Button, Box, Typography } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import CloseIcon from '@mui/icons-material/Close';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Check if already installed
    const standalone = window.matchMedia('(display-mode: standalone)').matches 
      || window.navigator.standalone 
      || document.referrer.includes('android-app://');
    
    setIsStandalone(standalone);

    // Check if device is mobile or tablet
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isTablet = /iPad|Android/i.test(navigator.userAgent) && window.innerWidth <= 1024;

    if (!standalone && (isMobile || isTablet)) {
      // Listen for beforeinstallprompt event
      const handleBeforeInstall = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
        
        // Show prompt after 5 seconds
        setTimeout(() => {
          const dismissed = localStorage.getItem('pwa-prompt-dismissed');
          if (!dismissed) {
            setShowPrompt(true);
          }
        }, 5000);
      };

      window.addEventListener('beforeinstallprompt', handleBeforeInstall);

      return () => {
        window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      };
    }
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    console.log(`User response: ${outcome}`);
    setDeferredPrompt(null);
    setShowPrompt(false);

    if (outcome === 'dismissed') {
      localStorage.setItem('pwa-prompt-dismissed', 'true');
    }
  };

  const handleClose = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa-prompt-dismissed', 'true');
  };

  // Don't show if already installed or not mobile/tablet
  if (isStandalone || !deferredPrompt) {
    return null;
  }

  return (
    <Snackbar
      open={showPrompt}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: { xs: 16, sm: 24 } }}
    >
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          borderRadius: 2,
          p: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          boxShadow: 3,
          maxWidth: 400,
        }}
      >
        <GetAppIcon fontSize="large" />
        <Box flex={1}>
          <Typography variant="subtitle2" fontWeight="bold">
            Instalar ConectaChurch
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Acesse rapidamente da tela inicial
          </Typography>
        </Box>
        <Box display="flex" gap={1}>
          <Button
            size="small"
            variant="contained"
            sx={{
              bgcolor: 'white',
              color: 'primary.main',
              '&:hover': { bgcolor: 'grey.100' },
            }}
            onClick={handleInstallClick}
          >
            Instalar
          </Button>
          <Button
            size="small"
            sx={{ color: 'white', minWidth: 'auto', px: 1 }}
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </Button>
        </Box>
      </Box>
    </Snackbar>
  );
};

export default PWAInstallPrompt;
